module.exports = __webpack_public_path__ + "img/five.2bd07485.jpg";